import { PaymentMethodListPage } from '@/features/payment-method/pages/PaymentMethodListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/payment-method/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["payment_methods.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PaymentMethodListPage,
})
